module.exports = __webpack_public_path__ + "assets/d06a6ec2511cb9766878448640482d81.mp3";